import { cn } from "@gymflow/helpers";
import { Row } from "@tanstack/react-table";
import { ReactNode } from "react";

import { Pagination } from "../molecules";
import { Table, TableProps } from "./Table";

export interface PaginatedTableProps<T> {
  className?: string;
  tableProps: TableProps<T>;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
  goToNextPage?: () => void;
  goToPreviousPage?: () => void;
  aboveTable?: ReactNode;
  rowClassName?: string;
  onRowClick?: (e: React.MouseEvent<HTMLTableRowElement>, row: Row<T>) => void;
}

export const PaginatedTable = <T,>({
  className,
  tableProps,
  hasPreviousPage,
  hasNextPage,
  goToNextPage,
  goToPreviousPage,
  aboveTable,
  rowClassName,
  onRowClick,
}: PaginatedTableProps<T>) => {
  return (
    <div
      className={cn(
        "h-full max-h-full w-full overflow-hidden rounded-xl border border-gray-200 bg-gray-0 shadow-sm",
        className,
      )}
    >
      {aboveTable}
      <div className="flex h-[calc(100%-4.75rem)]">
        <Table
          {...tableProps}
          manualSorting
          rowClassName={cn("h-14", rowClassName)}
          onRowClick={onRowClick}
        />
      </div>

      <Pagination
        className="min-h-fit p-4"
        hasNextPage={hasNextPage}
        hasPreviousPage={hasPreviousPage}
        goToNextPage={goToNextPage}
        goToPreviousPage={goToPreviousPage}
      />
    </div>
  );
};
